import Types from "./Types";

export const getStudentExamsRequest = (search = null) => ({
  type: Types.GET_ADMIN_STUDENT_EXAMS_MAIN_REQUEST,
  payload: search,
});

export const getStudentExamsSuccess = (data) => ({
  type: Types.GET_ADMIN_STUDENT_EXAMS_MAIN_SUCCESS,
  payload: data,
});

export const getStudentExamsFail = () => ({
  type: Types.GET_ADMIN_STUDENT_EXAMS_MAIN_FAIL,
});

export const redoExamRequest = (studentExamId, action) => ({
  type: Types.REDO_EXAM_REQUEST,
  payload: studentExamId,
  action: action,
});

export const redoExamSuccess = (data) => ({
  type: Types.REDO_EXAM_SUCCESS,
  payload: data,
});

export const redoExamFail = () => ({
  type: Types.REDO_EXAM_FAIL,
});

export const addStudentExamsLoading = (isLoading) => ({
  type: Types.ADD_ADMIN_STUDENT_EXAMS_LOADING,
  payload: isLoading,
});

